import { render, staticRenderFns } from "./CompanyDemonstrativeOfExercise.vue?vue&type=template&id=285d34f4&scoped=true&"
import script from "./CompanyDemonstrativeOfExercise.vue?vue&type=script&lang=ts&"
export * from "./CompanyDemonstrativeOfExercise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d34f4",
  null
  
)

export default component.exports